import { Loading } from '../loading';
import { ErrorMessage } from '../errorMessage';
import { ReactQueryLoaderProps } from '../../types';

// Wrapper for handling query states
export const ReactQueryLoader = ({
  children,
  status,
  error,
  ErrorComponent,
  LoadingComponent,
}: ReactQueryLoaderProps) => {
  if (status === 'loading') {
    return LoadingComponent ? <LoadingComponent /> : <Loading />;
  }

  if (status === 'pending') {
    return LoadingComponent ? <LoadingComponent /> : <Loading />;
  }

  if (status === 'error') {
    return ErrorComponent ? <ErrorComponent /> : <ErrorMessage msg={error?.message} />;
  }

  return children;
};
